// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".new-list-input {\n  border-radius: 2px;\n  height: 43px;\n}\n", "",{"version":3,"sources":["webpack://./css/react/AddToFavorites.less"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,YAAA;AACF","sourcesContent":[".new-list-input {\n  border-radius: 2px;\n  height: 43px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
